/**
 * @fileoverview Resolve one auth-shell string: consumer `t` → English default.
 * @module @puffin-core/auth-shell/strings/resolveString
 *
 * Byte-for-byte the contract `@puffin-core/login-shell` uses. A translator's return is treated as
 * MISSING — and the English default used — when it is nullish, empty, or the key echoed back, because
 * the last of those is exactly what react-i18next returns for an unregistered key. Without that
 * check an unwired app renders the raw dotted key as visible text.
 */

import { createStringResolver } from '@puffin-core/i18n-bootstrap/strings-kit';

import { DEFAULT_AUTH_SHELL_STRINGS } from './en.js';

/**
 * I18N-RENDER-002 Phase 0 (2026-08-20): bound from the ONE shared implementation, which carries the
 * `params`-forwarded-only-when-supplied rule so a consumer `t` whose own tests assert single-argument
 * arity keeps seeing one argument.
 *
 * 🔴 The invariant is now proved by BEHAVIOUR: `loginStringsWiring.contract.test.js` CALLS this
 * function through five arms plus an arity probe, rather than grepping this file for `/v !== key/`.
 *
 * @param {((key: string) => string|undefined|null)|undefined|null} t - optional consumer translator
 * @param {string} key
 * @param {Object} [params] - optional interpolation params forwarded to the consumer's `t`
 * @returns {string|undefined} the resolved string, or `undefined` for an unknown key
 */
export const resolveString = createStringResolver(DEFAULT_AUTH_SHELL_STRINGS);

export default resolveString;
